import CryptoJS from 'crypto-js';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

/** 时间戳 → 指定时区的时间字符串 */
export const formatTime = (ts: number, tz: string, fmt = 'YYYY-MM-DD HH:mm:ss') =>
  dayjs(ts).tz(tz).format(fmt);

/** 指定时区的时间字符串 → UTC 时间戳（传给后端） */
export const toTimestamp = (localStr: string, tz: string) =>
  dayjs.tz(localStr, tz).valueOf();


// base64编码 
export const encodeData = (data: unknown) => {
    const encodedData = new TextEncoder().encode(JSON.stringify(data));
    return btoa(
        String.fromCharCode.apply(null, Array.from(new Uint8Array(encodedData))),
    );
};
// 解码
export const decodeData = (data: string) => {
    if (!data) return null;
    try {
        const decodedString = atob(data);
        const decodedData = new TextDecoder().decode(
            new Uint8Array(decodedString.split("").map((char) => char.charCodeAt(0))),
        );
        return JSON.parse(decodedData);
    } catch (error) {
        console.error("Failed to decode data:", error);
        return null; // 或者抛出错误，取决于你的需求 
    }
};
// 对密码加密 
export const pwdEncrypt = (account:string,pwd: string) => {
    //拼接字符串，两次MD5加密 
    const passwd = `${account}${pwd}`;
    console.log(passwd);

    return CryptoJS.MD5(passwd).toString();
};

// 生成 UUID（用于 requestId）
export const generateRequestId = (): string => {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) {
        return crypto.randomUUID();
    }
    // fallback
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16) | 0;
        return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
};

/**
 * 签名
 * - POST + application/json: MD5( Base64(requestBody) + "_" + requestId + "_" + signKey )
 * - 其他请求: MD5( requestId + "_" + signKey )
 */
export const signMd5 = (requestId: string, base64Str?: string | null) => {
    const key = process.env.Ai_SAAS_SIGN_KEY ?? "";
    if (base64Str) {
        return CryptoJS.MD5(`${base64Str}_${requestId}_${key}`).toString();
    }
    return CryptoJS.MD5(`${requestId}_${key}`).toString();
};

/**
 * 生成符合正则表达式 /^(?=.*[a-z])(?=.*[A-Z]).{9,}$/ 的随机密码
 * @param {number} length - 密码长度，默认为12
 * @param {boolean} includeNumbers - 是否包含数字，默认为true
 * @param {boolean} includeSpecialChars - 是否包含特殊字符，默认为true
 * @returns {string} 生成的随机密码
 */
export function generatePassword(
    length = 12,
    includeNumbers = true,
    includeSpecialChars = true
) {
    // 参数验证
    if (length < 9) {
        console.warn('密码长度必须至少为9个字符，已自动调整为9');
        length = 9;
    }

    // 定义字符集
    const lowercaseChars = 'abcdefghijklmnopqrstuvwxyz';
    const uppercaseChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const numberChars = '0123456789';
    const specialChars = '!@#$%^&*()_+-=[]{}|;:,.<>?';

    // 构建可用字符集
    let availableChars = lowercaseChars + uppercaseChars;
    if (includeNumbers) {
        availableChars += numberChars;
    }
    if (includeSpecialChars) {
        availableChars += specialChars;
    }

    let password = '';
    const availableCharsLength = availableChars.length;

    // 确保至少有一个小写字母
    password += lowercaseChars.charAt(Math.floor(Math.random() * lowercaseChars.length));

    // 确保至少有一个大写字母
    password += uppercaseChars.charAt(Math.floor(Math.random() * uppercaseChars.length));

    // 填充剩余字符
    for (let i = 2; i < length; i++) {
        password += availableChars.charAt(Math.floor(Math.random() * availableCharsLength));
    }

    // 将密码字符打乱顺序（避免小写和大写字母总是在前两位）
    // Fisher-Yates 洗牌算法打乱字符串顺序
    password = password.split('').sort(() => Math.random() - 0.5).join('');

    return password;
}